import { FC } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Flex from '../Flex.tsx';
import SecondaryText from '../../typography/SecondaryText.tsx';

const HaveTroubleText: FC = () => {
  const { t } = useTranslation('component/have_trouble');

  return (
    <Flex.Wrapper gap="8px" className="text-gray-300 mx-auto">
      <SecondaryText className="whitespace-nowrap">{t('have_trouble')}</SecondaryText>

      <Link to={`${import.meta.env.VITE_LANDING_URL}contact-us/`} target="_blank">
        <SecondaryText className="underline whitespace-nowrap">{t('contact_us')}</SecondaryText>
      </Link>
    </Flex.Wrapper>
  );
};

export default HaveTroubleText;
